// Keeps track of which payment service provider is used
export enum PaymentServiceProvider {
  STRIPE = 'stripe',
  CLOVER = 'clover',
}
